/**
 * The Brand page's own words for the sections it composes.
 *
 * Here rather than in the cards for the same reason the product page keeps its own: the cards
 * are generic - an asset list, a text list - and the subject each one stands for is the page's
 * to state.
 */

/**
 * Everything the asset-list card cannot know about the brand's assets: what to call the list,
 * and how to name the wait and the failure. (Which role reads first is stated by
 * `toFileTypeRoles`, which is what orders them.)
 *
 * "Brand assets", not "Brand kit": this list is every file classified to the brand, whatever
 * role it plays, so naming it after the kit would understate what is in it.
 */
export const BRAND_ASSETS_WORDS = {
	title: 'Brand assets',
	loadingLabel: "Loading this brand's assets…",
	errorLabel: "Could not load this brand's assets. Please retry.",
	emptyLabel: 'No files are classified to this brand yet.',
}

/**
 * The same for the Copy tab. One reading of empty, not the product page's three: this page has
 * no filter rail and applies no narrowing, so a list can only be empty because nothing is
 * classified here - never because something was filtered away.
 */
export const BRAND_COPY_WORDS = {
	emptyLabel: 'No copy is classified to this brand or its products yet.',
}
